import React, { useEffect, useState } from 'react';
import objectiveIcon from "../../../assets/images/objective-icon.svg";

const RfpDescription = ({ data: dataObj, handleDataChange }: any) => {
    const [data, setData] = useState(dataObj?.content || '')

    useEffect(() => {
        if (dataObj?.updatedTime) {
            setData(dataObj.content)
        }
    }, [dataObj?.updatedTime])

    const handleObjectiveChange = (event: any) => {
        if (event.target.name === "objective") {
            let getTextArea = document.getElementById("textAreaRef");
            if (getTextArea) {
                if (event.target.value.length === 0) {
                    event.target.style.height = "24px";
                } else {
                    event.target.style.height = "auto";
                    event.target.style.height = event.target.scrollHeight + "px";
                }
            }
            setData(event.target.value)
            handleDataChange({ key: dataObj?.key, value: event.target.value })
        }
    };

    return (
        <>
            <div className="mb-6">
                <p className="text-[#344054] text-sm font-interMedium pb-1.5">
                    {dataObj?.title}
                </p>
                <div className="relative">
                    <div className="border border-[#D0D5DD] rounded-lg flex items-start gap-x-2 py-2 px-3 hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                        <textarea
                            id="textAreaRef"
                            name="objective"
                            value={data}
                            onChange={handleObjectiveChange}
                            className="placeholder:text-[#D0D5DD] placeholder:font-interLight placeholder:text-base text-base text-[#344054] w-full h-[24px]"
                            placeholder="Enter here"
                            style={{
                                width: "100%",
                                boxSizing: "border-box",
                                overflow: "hidden",
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default RfpDescription